var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "55px",
    viewBox: "0 0 66 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2479608C-EBE8-4059-ABB8-1D7E7FEB928F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.-what-can-help",
    transform: "translate(-358.000000, -585.000000)",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(360.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.171055,24.55545 L14.171505,22.8885 C14.159655,20.70795 15.934605,18.9102 18.115155,18.8987468 L18.727005,18.8987468 C20.907705,18.88755 22.701105,20.6619 22.713105,22.8426 L22.713105,24.55545",
    id: "Stroke-1",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.50202,31.706385 C12.50202,33.363135 13.92897,34.718835 15.67392,34.718835 L21.21897,34.718835 C22.96347,34.718835 24.39087,33.363135 24.39087,31.706385 L24.39087,26.232585 C24.39087,25.941585 24.15282,25.703535 23.86227,25.703535 L13.03062,25.703535 C12.73947,25.703535 12.50202,25.941585 12.50202,26.232585 L12.50202,31.706385 Z",
    id: "Stroke-3",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.446205,
    y1: 29.292915,
    x2: 18.446205,
    y2: 31.550565,
    id: "Stroke-5",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.877755,29.142765 C18.877755,29.382015 18.685755,29.574315 18.446655,29.574315 C18.208755,29.574315 18.014655,29.382015 18.014655,29.142765 C18.014655,28.903365 18.208755,28.711065 18.446655,28.711065 C18.685755,28.711065 18.877755,28.903365 18.877755,29.142765 Z",
    id: "Stroke-7",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.46112,27.68172 L45.58002,27.68172 L54.65262,38.20902 L54.65442,27.68172 L57.10662,27.68172 C59.87202,27.68172 62.13372,25.42017 62.13372,22.65447 L62.13372,5.02722 C62.13372,2.26152 59.87202,-3e-05 57.10662,-3e-05 L30.69927,-3e-05 C27.93372,-3e-05 25.67217,2.26152 25.67217,5.02722 L25.67217,8.93052",
    id: "Stroke-9",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.481115,51.046275 L7.479315,40.519125 L5.025465,40.519125 C2.261715,40.519125 1.5e-05,38.257425 1.5e-05,35.491875 L1.5e-05,17.864625 C1.5e-05,15.099075 2.261715,12.837225 5.025465,12.837225 L31.433565,12.837225 C34.199265,12.837225 36.460815,15.099075 36.460815,17.864625 L36.460815,35.491875 C36.460815,38.257425 34.199265,40.519125 31.433565,40.519125 L16.551915,40.519125 L7.481115,51.046275 Z",
    id: "Stroke-11",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.078825,
    y1: 8.06469,
    x2: 34.566675,
    y2: 8.06469,
    id: "Stroke-13",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.078825,
    y1: 17.609895,
    x2: 40.880775,
    y2: 17.609895,
    id: "Stroke-15",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.078825,
    y1: 12.837285,
    x2: 40.880775,
    y2: 12.837285,
    id: "Stroke-17",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleLock);
export default __webpack_public_path__ + "static/media/bubbleLock.6855f6c1.svg";
export { ForwardRef as ReactComponent };